export default __webpack_public_path__ + "static/media/expand.b3bc8b00.svg";